import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, Subscription, debounceTime, takeUntil } from 'rxjs';
import { GetDivisions$Params } from 'src/api/generated/fn/divisions/get-divisions';
import { RemoveDivision$Params } from 'src/api/generated/fn/divisions/remove-division';
import { DivisionDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/division-dto';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { DivisionsService } from 'src/api/generated/services';
import { AddOrEditDivisionComponentV2 } from './add-or-edit-division/add-or-edit-division.component';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.scss']
})
export class DivisionComponent implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();
  public venueId: string;
  public divisions :Array<DivisionDto>;
  public searchTerm: string = "";
  searchDebouncer = new Subject<void>();
  RELOAD_DEBOUNCE_TIME = 500;
  loading: boolean = true;

  venueIdUpdateSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private currentVenueHelper: CurrentVenueHelperService,
    private router: Router,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private divisionService : DivisionsService
  ) {

    this.route.params.subscribe(params => {
      this.venueId = params['venue-id'];
      this.getDivisionForVenue();
      this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
    });  
   }

  ngOnInit(): void {
    this.searchDebouncer.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.getDivisionForVenue());
  }

  getDivisionForVenue() {
    this.loading = true;
    var params: GetDivisions$Params= {} as GetDivisions$Params;
    params.venueId = this.venueId;
    params.isRemoved = false;  
    if(this.searchTerm){
      params.searchTerm = this.searchTerm;
    }
    
    this.divisionService.getDivisions(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.divisions = response.divisions ? response.divisions : [];
          this.loading = false;
        },
        error: errorResponse => {
        }
      });
  }

  newDivision(){
    const ref = this.dialogService.open(AddOrEditDivisionComponentV2, {
      width: '372px',
      showHeader: false,
      closeOnEscape: false,
      data: {
        venueId: this.venueId
      }
    });
    ref.onClose.subscribe((item: any) => {
      this.getDivisionForVenue();
    });
  }
  editDivision(division : DivisionDto){
    const ref = this.dialogService.open(AddOrEditDivisionComponentV2, {
      width: '372px',
      showHeader: false,
      closeOnEscape: false,
      data: {
        venueId: this.venueId,
        item: division
      }
    });
    ref.onClose.subscribe((item: any) => {
       this.getDivisionForVenue();
    });
  }
  deleteDivision(division:DivisionDto){
    this.confirmationService.confirm({
      header: this.translate.instant('DIVISION.DELETE_DIVISION_TITLE') + "?",
      message: this.translate.instant('DIVISION.DELETE_DIVISION_TEXT') + division.name + " ?",
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      closeOnEscape: false,
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        var params: RemoveDivision$Params = {} as RemoveDivision$Params;
        if (division.id) {
          params.divisionId = division.id;
        }
        this.divisionService.removeDivision(params)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              this.getDivisionForVenue()
            },
            error: errorResponse => {
            }
          });
      }
    });
  }
  search(){
    this.loading = true;
    this.searchDebouncer.next();
  }
}
